import { useState, type ChangeEvent, type FunctionComponent } from 'react';
import RadioOptionProps from '../../../interfaces/radioOptionProps';
import breakpoints from '../../../utils/breakpoints';
import { subQuestionStyles } from '../../../utils/subQuestionStyles';
import useCurrentWidth from '../../commons/use-current-width/useCurrentWidth';
import * as styles from './RadioOption.module.css';

const RadioOption: FunctionComponent<RadioOptionProps> = ({
  option,
  questionId,
  isSubQuestion,
  onChange,
  checked,
  additionalText,
  isOtherOption,
  onChangeInputText,
  grayedOut,
}) => {
  const [value, setValue] = useState(additionalText || '');

  const inputTextChanged = (element: ChangeEvent<HTMLInputElement>) => {
    const newContent = element.target.value;
    setValue(newContent);
    onChangeInputText && onChangeInputText({ newContent });
  };

  const { id } = option;
  const currentWidth = useCurrentWidth();
  const isMobile = currentWidth < breakpoints.medium;
  const isDesktop = currentWidth >= breakpoints.medium;
  const displayLabel = isMobile || (isDesktop && !isSubQuestion);
  const displayInputText = isOtherOption && checked;

  return (
    <div
      data-testid="sub-question-radio-option"
      className={`${styles.radioOptionWrapper} ${subQuestionStyles({
        styles,
        isSubQuestion,
      })} 
        ${grayedOut ? styles.grayedOut : ''}`}
    >
      <input
        className={styles.radioInput}
        type="radio"
        id={`${id}`}
        key={`${questionId}-${id}`}
        name={`${questionId}`}
        onChange={() => onChange({ newOption: option, isOtherOption })}
        checked={checked}
        data-testid={`question-radio-${id}`}
      />
      {displayLabel && <div className={styles.label}>{option.description}</div>}
      {displayInputText && (
        <input type="text" className={styles.textInput} value={value} onChange={inputTextChanged} />
      )}
    </div>
  );
};

export default RadioOption;
